import { render } from "./AssistantReplyTextSegment.vue?vue&type=template&id=4db4709b"
import script from "./AssistantReplyTextSegment.vue?vue&type=script&lang=js"
export * from "./AssistantReplyTextSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__